/**
 * Centralized constants for Datadog action names
 * Used with data-dd-action-name attributes for tracking user interactions
 * across all packages in the monorepo
 */

// @deprecated: We might deprecate these in favor of the new feature tracking utility
export const DATADOG_ACTIONS = {
  // Motion-related actions
  USE_MOTION: 'Use motion',
  ADD_MOTION: 'Add motion',
  GENERATE_MOTION: 'Generate motion',
  GENERATE_POSE: 'Generate pose',

  // Character-related actions
  GENERATE_CHARACTER: 'Generate character',

  // Authentication actions
  JOIN_NOW: 'Join now',
  CONTINUE_WITH_GOOGLE: 'Continue with Google',
} as const;

// Legacy exports for backward compatibility (can be removed after migration)
export const DD_GENERATE_CHARACTER_ACTION_NAME =
  DATADOG_ACTIONS.GENERATE_CHARACTER;
export const DD_GENERATE_MOTION_ACTION_NAME = DATADOG_ACTIONS.GENERATE_MOTION;
